'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'file-exclamation';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f31a';
var svgPathData = 'M213.5 0c17 0 33.2 6.8 45.2 18.8L365.3 125.2c12 12 18.7 28.3 18.7 45.2L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L213.5 0zM192 400c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm0-176c-18.3 0-32.8 15.7-31.2 34l7.3 88c1 12.4 11.4 22 23.9 22s22.9-9.6 23.9-22l7.3-88c1.5-18.3-12.9-34-31.3-34zm16-72c0 13.3 10.7 24 24 24l93.5 0-117.5-117.5 0 93.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;